import React from 'react'
import {Button} from "@material-ui/core";

import {
  PopupTitle,
  PopupContainer,
  PopupDescription,
  PopupButtonsContainer,
} from "../HygienistJobDetails.styles";

interface WithdrawActionsProps {
  onApplicationWithdraw: () => void
  onCancel: () => void
}

const WithdrawActions = ({
  onApplicationWithdraw,
  onCancel,
}: WithdrawActionsProps) => {
  return (
    <PopupContainer>
      <PopupTitle>Withdraw Application</PopupTitle>
      <PopupDescription>
        Are you sure you would like to withdraw your application to this job? This employer will no longer be able to view your resume for this job
      </PopupDescription>
      <PopupButtonsContainer>
        <Button
          variant="outlined"
          onClick={onCancel}
          color="primary"
          size="large"
          id="review-button"
          className="bigButtonInNewStyle"
        >
          Cancel
        </Button>
      </PopupButtonsContainer>
      <PopupButtonsContainer>
        <Button
          variant="contained"
          onClick={onApplicationWithdraw}
          color="primary"
          size="large"
          id="review-button"
          className="bigButtonInNewStyle"
        >
          Withdraw My Application
        </Button>
      </PopupButtonsContainer>
    </PopupContainer>
  )
}

export default WithdrawActions;
